// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./consentpost.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var checkbox = require("../checkbox/checkbox");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).consentpost;
var parsing = require('parsing').consentpost;
var moduleHelper = require('../../scripts/module-helper');

var isAdmin = ( MBGF && MBGF.isAdmin == '1' );

function parse(text, next) {
    strip(require('raw!./consentpost.html'), function(outputHtml) {
        var match = parsing.parse(text);

        var options;

        if (match) {

            var container = document.createElement("div");
            container.innerHTML = outputHtml;
            var domObj = container.firstChild;

            // add a "required" class to the parent node
            // domObj.setAttribute("class", domObj.getAttribute("class") + " required");
            // domObj.setAttribute("data-required", "true");

            //if( !isAdmin ) {
                //outputHtml = container.innerHTML.replace(" = (", "* = (");
            //}
            //else {
                outputHtml = container.innerHTML;
            //}

            text = text.replace(match[0], outputHtml);
            next(text);
        }
        else {
            next(text);
        }
    });

};

function validate(context, err) {

    return true;

    var value = get(context);

    // If nothing is chosen, then its ok and considered valid.
    if (!value) {
        return true;
    }


    var validationResult =  !err ? validation.validate(value, true) : err;

    var messagelabel = context.querySelector("#txt_consentpost-error");
    messagelabel.innerHTML = "";

    if (!validationResult.valid) {
        //input.setAttribute("class", currentClasses + " error");
        var message = document.createTextNode(context.getAttribute("data-msg-required"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " error");
    }
    else {
        //input.setAttribute("class", currentClasses + " valid");
        var message = document.createTextNode(context.getAttribute("data-msg-valid"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " valid");
    }

    return validationResult.valid;
}

function init(formRoot, meta, next) {
    var context = formRoot.querySelector('[data-module="consentpost"]');

    if( context ) {
        moduleHelper.fields.radiobutton.bindValidationEvents(context, validate);
    }

    next(formRoot);
}


function get(context) {
    var value = checkbox.get(context);
    return value ? 'denypost' : 'consentpost'; // value : null;
}

function reset(context) {
    checkbox.reset(context);
}

// This will transform the data so it simulates how it was before the consentpost was inverted.
// We make sure to add the same result as we had when someone checked the consentbox, no matter if
// the have checked it or not. But the data is transformed in different ways.
function transform(key, data) {

    if (data[key] === 'consentpost') {
        data['checkbox.consentpost'] = data[key];
    } else if (data[key] === 'denypost') {
        data['checkbox.consentpost'] = data[key];
    }

    if (key === 'denypost') {
        delete data['checkbox.denypost'];
    }

    return data;

}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    reset: reset,
    transform: transform,
    // dataKey: contentpost'
};





// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/consentpost/consentpost.js